import cover1 from '../assets/images/cover1.jpeg';
import cover2 from '../assets/images/cover2.jpeg';
import cover3 from '../assets/images/cover3.jpeg';


export const ImageDir = {
    building: require('../assets/images/bulid.jpeg'),
    chairman: require('../assets/images/Chairperson.png'),
    director: require('../assets/images/WhatsApp Image 2024-03-12 at 20.20.03 (6).jpeg'),
    principalImg: require('../assets/images/Princi.png'),


    faculty : require('../assets/images/WhatsApp Image 2024-03-12 at 20.20.00 (3).jpeg'),
    awards: require('../assets/images/WhatsApp Image 2024-03-12 at 20.20.03.jpeg'),
    laboratory: require('../assets/images/Lab.JPG'),
    classroom: require('../assets/images/classroom.JPG'),
    hostels: require('../assets/images/hostel.JPG'),


    drone1: require('../assets/new_images/C_2_copy.jpg'),
    drone2: require('../assets/new_images/C_1.jpg'),

    placementsCover: require('../assets/images/classroom.JPG'),
    scholarshipCover: require('../assets/images/hostel.JPG'),

    covers: [
        require('../assets/new_images/C_2_copy.jpg'),
        // require('../assets/images/Untitled design-2.png'),
        require('../assets/images/cover2.jpeg'),
        require('../assets/images/cover3.jpeg'),],
    aff_json: [
        {
            name: 'Directorate Of Medical Education',
            logo: require('../assets/images/affiliation_logos/Gov_of_Tripura.png')
        },
        {
            name: `Tripura University`,
            logo: require('../assets/images/affiliation_logos/Tripura_University_Logo.png')
        },
        {
            name: 'Govt. of Tripura',
            logo: require('../assets/images/affiliation_logos/Gov_of_Tripura.png')
        },
        {
            name: 'Tripura Nursing Council',
            logo: require('../assets/images/affiliation_logos/Tripura_Nursing_Council.png')
        },
        {
            name: 'Indian Nursing Council',
            logo: require('../assets/images/affiliation_logos/Indian_Nursing_Council.png')
        }
    ],

    programs:
        [
            {
                "title": "B.Sc. Nursing",
                "coverImageUrl":require("../assets/images/WhatsApp Image 2024-03-12 at 20.20.02.jpeg"),
                "description":
                    "B. Sc. Nursing is a four-year Graduate programme focused on developing critical care, advanced thinking skills, proficiency and values necessary for the practice of professional nursing and midwifery as mentioned in the National Health Policy 2002. The programme is streamlined to enable students to address the health needs of the nation, society and individuals. The programme prepares students to become responsible citizens by following a code of moral values and conduct at all times while fulfilling personal, social and professional responsibilities to respond to national objectives. B. Sc. Nursing programme involves classroom study, projects and assignments that enable students to gain practical knowledge of their learning. After the completion of the programme, the students are required to undergo a  six-month internship to experience real-world clinical settings and learn from them. Candidates looking for more knowledge in the same field may pursue higher education for challenging career opportunities."

                ,
                "eligibility": [
                    {
                        "description": "10+2 with Physics, Chemistry, Biology with atleast 45% and pass in English Subject from a recognized board."
                    }
                ],
                "duration": "4 Years",
                "age_limit": "17+ Years"
            },

            {
                "title": "GNM Nursing",
                "coverImageUrl":require("../assets/images/WhatsApp Image 2024-03-12 at 20.20.02 (4).jpeg"),
                "description":
                    "GNM Nursing Course, or General Nursing and Midwifery, is a three-years diploma programme designed for those interested in a career in clinical nursing. The programme teaches candidates how to care for people who are ill or injured to help them recover completely. \n" +
                    "The GNM Nursing course teaches both theories and practises in the field of nursing. All types of training are available, ranging from community health to minor surgery.\n" +
                    "\n" +
                    "The three years programme includes a six-month intemmship requirement. GNM Nursing course is one of the courses that can be used as a stepping stone to a career in the Nursing field\n" +
                    "\n" +
                    "The GNM Nursing course is an essential component of the healthcare system that promotes health screening and illness prevention across the entire spectrum of health GNM (GENERAL NURSING AND care. Throughout the course, a large number of inputs are MIDWIFERY) provided, including modules and subjects such as anatomy and physiology. \n"
                ,
                "eligibility": [
                    {
                        "description": "10+2 class passed preferably Science (PCB) & English with an aggregate of 40% marks."
                    },
                    {
                        "description": "10+2 in Arts (Mathematics, Biotechnology, Economics, Political Science, History, Geography, Business Studies, Accountancy, Home Science Sociology, Psychology, Philosophy) and English Core/English Elective or Health Care Science - Vocational Stream Only, Passing out from a recognized board under AISSCE/CBSE/ISCE/SSCE/HSCE or other equivalent Board."
                    },
                    {
                        "description": "Nationality should be Indian."
                    }
                ],
                "duration": "3 Years",
                "age_limit": "17+ Years"
            },


        ]



}